var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-label"},[_c('input',{ref:"checkbox",staticClass:"checkbox-label__checkbox",attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"checkbox-label__text mr-3"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }